
import { Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  LoadingController, NavController, ToastController } from '@ionic/angular';
import { EventProvider } from '../../providers/event/event';
import { SessionProvider } from '../../providers/session/session';
import { UserProvider } from '../../providers/user/user';
import { Router } from '@angular/router';
import { ValueProvider } from 'src/providers/value/value';

declare let Stripe;
declare let paypal: any;

@Component({
    selector: 'page-instant-payment',
    templateUrl: 'instant-payment.html',
    styleUrls:['./instant-payment.scss']
})
export class InstantPaymentPage {
    @ViewChild('paypal') paypalElement: ElementRef;

    stripePublish = Stripe('pk_live_51IefWZEfWOjwetWPU7hpUsj3lIDQ7ziEQsRz62QIMnMhwK3WIgw0i8MWsK1kNDIzm5wSZikS7NYXeFgmfazOcaks0070GwcWzm');

    profile = {
        forName: '',
        surName: '',
        amount: 1,
        quantity: 1,
        email: '',
        id: -1,
        homeStreet:'',
        homeStreetNo:'',
        zip:0,
        city:'',
        country:''
    }

    currency = "eur";
    cardElement: any;
    ibanElement: any;
    paymentSuccessful: boolean = false;
    paidFor: boolean = false;
    didRenderPaypal: boolean = false;
    paymentMethod: string = "";
    token = "AAA";

    isAddress:boolean=false;
    countries:any

    constructor(
        private loadingCtrl: LoadingController,
        private eventService: EventProvider,
        private toast: ToastController,
        private translate: TranslateService,
        private router:Router,
        private userService: UserProvider,
        private sessionService: SessionProvider,
        private navCtrl:NavController,
        private valueService:ValueProvider,
    ) {
        this.valueService.getCountries()
            .then(countries => {
                this.countries = countries;
            })
            .catch(error => {
                console.error('Failed to load countries', error);
            });
        const nav = this.router.getCurrentNavigation();
        const state = nav?.extras?.state || {};
        let c = state['c'];
        if (c) {
            this.profile.forName = c.firstName;
            this.profile.surName = c.lastName;
            this.profile.amount = c.count;
            this.profile.quantity = c.amount;
            this.profile.email = c.mail;
            this.profile.id = c.evId;
            this.translate.setDefaultLang(c.lang);
        } else {
            this.profile.quantity = state['amount'];
            this.profile.id = state['id'];
            this.currency = state['currency'];
        }

        if(state['address']==="true"){
            this.isAddress = true
        }else{
            this.isAddress = false
        }

        this.userService.login({ email: "test@liferay.com", password: "tobzasi12" }).then((token) => {
            this.sessionService.getToken().then(token => {
                this.token = token;
            });
        })
    }

    logForm(form) {
        console.log(form.value)
    }

    async setPaymentMethod(paymentMethod) {
        if (!this.checkRequiredFields()) return;

        let loader = await this.loadingCtrl.create();
        loader.present();
        this.paymentMethod = paymentMethod;
        setTimeout(() => {
            if (this.paymentMethod.includes('stripe-credit')) {
                this.setupStripeCredit();
            } else if (this.paymentMethod.includes('stripe-debit')) {
                this.setupStripeDebit();
            } else if (this.paymentMethod.includes('paypal')) {
                this.setupPayPal();
            }
            loader.dismiss();
        }, 2000);
    }

    checkRequiredFields() {
        // this.profile.quantity = Number((this.profile.quantity + "").replace(',', '.'));

        if (this.profile.quantity <= 0) {
            this.showToast(this.translate.instant('WARN_MESSAGE_DOUBLE'));
            return false;
        }
        if ((this.profile.amount + "").includes('.')) {
            this.showToast(this.translate.instant('WARN_MESSAGE_INTEGER'));
            return false;
        }
        if (!this.profile.email.includes("@") && !this.profile.email.includes(".")) {
            this.showToast(this.translate.instant('WARN_MESSAGE_EMAIL'));
            return false;
        }
        if (this.profile.forName.length < 1 || this.profile.surName.length < 1 || this.profile.email.length < 1 || (this.profile.amount + "").length < 1 || (this.profile.quantity + "").length < 1) {
            this.showToast(this.translate.instant('WARN_MESSAGE_FIELDS_EMPTY'));
            return false;
        } else {
            return true;
        }
    }

    isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    setupStripeCredit() {
        let elements = this.stripePublish.elements();
        var style = {
            base: {
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                color: '#32325d',
                lineHeight: '24px',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        this.cardElement = elements.create('card',
            { hidePostalCode: true, style: style });
        this.cardElement.mount('#card-element');

        this.cardElement.addEventListener('change', event => {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });
    }

    setupStripeDebit() {
        let elements = this.stripePublish.elements();
        var style = {
            base: {
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                color: '#32325d',
                lineHeight: '24px',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        let options = {
            style: style,
            supportedCountries: ['SEPA'],
            placeholderCountry: 'DE'
        };
        this.ibanElement = elements.create('iban', options);
        this.ibanElement.mount('#iban-element');
    }

    async payCreditCard() {
        let loader = await this.loadingCtrl.create({});
        loader.present();

        let params = {
            amount: this.profile.quantity * 100 * ((this.profile.amount > 1) ? this.profile.amount : 1),        //amount is in cents
            currency: this.currency.toLowerCase(),
            paymentMethodType: "card"
        };

        if ((params.amount + "").includes('.')) {
            params.amount = Number((params.amount + "").split('.')[0]);
        }

        let path = "pay?type=" + params.paymentMethodType + "&amount=" + params.amount + "&currency=" + params.currency;

        this.eventService.makeIntent(path).then((paymentClientIntent) => {
            this.confirmCardPayment(paymentClientIntent).then(() => {
                this.showToast(this.translate.instant('PAYMENT_SUCCESS'));
                loader.dismiss();
            }).catch(err => {
                this.showToast(this.translate.instant('PAYMENT_FAILURE'));
            });
        }).catch(err => alert(err));
    }

    paySepaDebit() {
        //DE89370400440532013000
        let params = {
            amount: this.profile.quantity * 100 * ((this.profile.amount > 1) ? this.profile.amount : 1),        //amount is in cents
            currency: this.currency.toLowerCase(),
            paymentMethodType: "sepa_debit"
        };

        if ((params.amount + "").includes('.')) {
            params.amount = Number((params.amount + "").split('.')[0]);
        }

        let path = "payment/" + params.paymentMethodType + "/" + params.amount + "/" + params.currency;

        console.log('path: ', path);
        this.eventService.makeIntent(path).then((paymentClientIntent) => {
            this.confirmSepaDebitPayment(paymentClientIntent);
        });
    }

    createFinishPaymentLink() {
        //https://m.gofo.rest/#/payment_success?token=AAA&evId=1232&count=1&amount=12.50&firstName=slavik&lastName=spasibo&mail=test@gmail.com

        return "https://m.gofo.rest/#/success_transaction?token=" + this.token + "&evId=" + this.profile.id + "&count=" + this.profile.amount + "&amount=" + this.profile.quantity + "&firstName=" + this.profile.forName + "&lastName=" + this.profile.surName + "&mail=" + this.profile.email;
    }


    async confirmCardPayment(clientSecret) {
        const name = this.profile.forName + " " + this.profile.surName;
        const { error: stripeError, paymentIntent } = await this.stripePublish.confirmCardPayment(
            clientSecret,
            {
                payment_method: {
                    card: this.cardElement,
                    billing_details: {
                        name: name,
                    },
                },
            }
        );

        if (stripeError) {
            console.log(stripeError.message);
            alert(stripeError.message);
            // reenable the form.
            return;
        }

        let c = {
            token: this.token,
            evId: this.profile.id,
            count: this.profile.amount,
            amount: this.profile.quantity,
            firstName: this.profile.forName,
            lastName: this.profile.surName,
            mail: this.profile.email,
            lang: "de"
        }

        this.eventService.saveCoupon(c).then((image) => {
            this.navCtrl.navigateForward('/success-payment', {state:{image: image, token: this.token }});
            // (this.app.getRootNav() as NavController).push(SuccessPaymentPage, { image: image, token: this.token });
            // show the new Page with full screen image + share
            console.log(`Payment ${paymentIntent.status}: ${paymentIntent.id}`);
        });
    }

    async confirmSepaDebitPayment(clientSecret) {

        const { error: stripeError, paymentIntent } = await this.stripePublish.confirmSepaDebitPayment(
            clientSecret,
            {
                payment_method: {
                    sepa_debit: this.ibanElement,
                    billing_details: {
                        name: this.profile.forName + ' ' + this.profile.surName,
                        email: this.profile.email
                    },
                },
            }
        );

        if (stripeError) {
            console.log(stripeError.message);
            console.log('error: own');
            // reenable the form.
            return;
        }

        this.showToast(this.translate.instant('PAYMENT_SUCCESS'));

        console.log(`Payment ${paymentIntent.status}: ${paymentIntent.id}`);
    }

    async setupPayPal() {
        let that = this;
        if (!this.didRenderPaypal) {
            let locale = this.translate.getDefaultLang().toUpperCase().includes("DE") ? "de_DE" : "en_US";

            this.loadPaypalScript().then(() => {
                // paypal.Button.render(this.paypalConfig, '#paypal-btn');

                let configs = {
                    // Configure environment
                    env: 'production',
                    client: {
                        sandbox: 'EIRqdIcSWCi68lcQJZw2pGqdSvHkzzop1OCgaFCa4Ur5wf1-Mxf4nSo5jJ4SqKkAm51tph_oztBxN-HY',
                        production: 'AVhHIfBCVbqZWzW-PoFAZXoeJl5u8yT80Y8d1hl2tK8oIpW2tZ-rO7hFn2hC0l0-aivACU0NWMB1KG9m'
                    },
                    // Customize button (optional)
                    locale: locale,
                    style: {
                        size: 'small',
                        color: 'gold',
                        shape: 'pill',
                    },

                    // Enable Pay Now checkout flow (optional)
                    commit: true,

                    // Set up a payment
                    payment: function (data, actions) {
                        return actions.payment.create({
                            transactions: [{
                                amount: {
                                    total: that.profile.quantity * ((that.profile.amount > 1) ? that.profile.amount : 1),
                                    currency: that.currency.toUpperCase()
                                }
                            }]
                        });
                    },
                    // Execute the payment
                    onAuthorize: function (data, actions) {
                        return actions.payment.execute().then(function () {
                            // Show a confirmation message to the buyer
                            that.onPaymentSuccessful();
                        });
                    }
                };

                paypal
                    .Button.render(configs, this.paypalElement.nativeElement);
            });
        }
    }

    loadPaypalScript(): Promise<any> {
        this.didRenderPaypal = true;
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = 'https://www.paypalobjects.com/api/checkout.js';
            scriptElement.onload = resolve;
            document.body.appendChild(scriptElement);
        });
    }

    onPaymentSuccessful() {
        let c = {
            token: this.token,
            evId: this.profile.id,
            count: this.profile.quantity,
            amount: this.profile.amount,
            firstName: this.profile.forName,
            lastName: this.profile.surName,
            mail: this.profile.email,
            lang: "de"
        };

        this.eventService.saveCoupon(c).then((image) => {
            this.paymentSuccessful = true;
            this.showToast(this.translate.instant('PAYMENT_SUCCESS'));
            this.navCtrl.navigateForward('/success-payment', {state:{image: image}});
            // (this.app.getRootNav() as NavController).push(SuccessPaymentPage, { image: image });
            // show the new Page with full screen image + share
        });

    }

    async payGiropay() {
        if (!this.checkRequiredFields()) return;

        let loader = await this.loadingCtrl.create({});
        loader.present();

        let params = {
            amount: this.profile.quantity * 100 * ((this.profile.amount > 1) ? this.profile.amount : 1),        //amount is in cents
            currency: this.currency.toLowerCase(),
            paymentMethodType: "giropay"
        };

        if ((params.amount + "").includes('.')) {
            params.amount = Number((params.amount + "").split('.')[0]);
        }

        let path = "pay?type=" + params.paymentMethodType + "&amount=" + params.amount + "&currency=" + params.currency;

        this.eventService.makeIntent(path).then((paymentClientIntent) => {
            this.confirmGiropay(paymentClientIntent).then((isSuccessful) => {
                if (isSuccessful) loader.dismiss();
            });
        }).catch(err => {
            loader.dismiss();
        });

    }

    confirmGiropay(clientIntent) {
        return new Promise<any>((resolve, reject) => {
            this.stripePublish.confirmGiropayPayment(
                clientIntent,
                {
                    payment_method: {
                        billing_details: {
                            name: this.profile.forName + ' ' + this.profile.surName
                        }
                    },
                    return_url: this.createFinishPaymentLink(),
                }
            ).then(function (result) {
                if (result.error) {
                    // Inform the customer that there was an error.
                    console.log(result.message);
                    resolve(false);
                } else {
                    resolve(true);
                }
            });
        });
    }

    async paySofort() {
        if (!this.checkRequiredFields()) return;

        let loader = await this.loadingCtrl.create({});
        loader.present();

        let params = {
            amount: this.profile.quantity * 100 * ((this.profile.amount > 1) ? this.profile.amount : 1),        //amount is in cents
            currency: this.currency.toUpperCase(),
            paymentMethodType: "sofort"
        };

        if ((params.amount + "").includes('.')) {
            params.amount = Number((params.amount + "").split('.')[0]);
        }

        let path = "pay?type=" + params.paymentMethodType + "&amount=" + params.amount + "&currency=" + params.currency;

        this.eventService.makeIntent(path).then((paymentClientIntent) => {
            this.confirmSofort(paymentClientIntent).then((isSuccessful) => {
                if (isSuccessful)
                    loader.dismiss();
            });
        }).catch(err => {
            loader.dismiss();
        });
    }

    confirmSofort(clientIntent) {
        return new Promise<any>((resolve, reject) => {
            this.stripePublish.confirmSofortPayment(
                clientIntent,
                {
                    payment_method: {
                        sofort: {
                            country: 'DE',
                        },
                        billing_details: {
                            name: this.profile.forName + ' ' + this.profile.surName,
                            email: this.profile.email
                        }
                    },
                    return_url: this.createFinishPaymentLink(),
                }
            ).then(function (result) {
                if (result.error) {
                    // Inform the customer that there was an error.
                    console.log(result.message);
                    // this.showToast(this.translate.instant('PAYMENT_FAILURE'));
                    resolve(false);
                } else {
                    // this.showToast(this.translate.instant('PAYMENT_SUCCESS'));
                    resolve(true);
                }
            });
        });
    }

    showToast(message) {
        let toast = this.toast.create({
            message: message,
            duration: 3000,
            position: 'top'
        }).then(toast=>toast.present());
    }
    onCountryChange(event:any){
        this.profile.country = event.detail.value;
    }
}
